import 'ui-theme/js/components/_tabs';

+(function (UX) {
    const {tab} = UX;
    const {control} = tab;
    tab.control = () => {
        [...document.querySelectorAll('.tab__nav .external')].forEach(link =>
            link.addEventListener('click', function () {
                location.href = link.href;
            })
        );
        control();
    };
})(UX);
